import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getNode } from "actions/workflows";
import NiceModal from "@ebay/nice-modal-react";
import NodeForm from "components/Forms/NodeForm";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import Button from "components/Elements/Button";

const Node = () => {
  const navigate = useNavigate();
  const { node_id } = useParams();
  const { node, functionToAdd } = useSelector((state) => state.workflows);
  const [localNode, setLocalNode] = useState({
    id: "",
    public_id: "",
    name: "",
    description: "",
    functions: [],
  });
  const [functionsArray, setFunctionsArray] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (node_id) {
      dispatch(getNode(node_id));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (functionToAdd) {
      const functionToAddArray = [
        functionToAdd.id,
        functionToAdd.public_id,
        functionToAdd.name,
        functionToAdd.description,
        <></>,
      ];
      setFunctionsArray([...functionsArray, functionToAddArray]);
      setLocalNode({
        ...localNode,
        functions: [...localNode.functions, functionToAdd],
      });
    }
    // eslint-disable-next-line
  }, [functionToAdd]);

  useEffect(() => {
    //dispatch(clearNode());
    if (!node_id && !node) {
      return;
    }

    if (node) {
      if (!node.functions) {
        node.functions = [];
      } else {
        const functions = node.functions.map((f) => {
          const values = [f.id, f.public_id, f.name, f.description, <></>];
          return values;
        });
        setFunctionsArray(functions);
      }
    }
    setLocalNode(node);
    // eslint-disable-next-line
  }, [node]);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("STATE: ", location);
  }, [location]);

  if (!localNode && node_id) return <>Loading...</>;

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <div
                  onClick={() => navigate("/admin/nodes")}
                  className="text-blueGray-500 hover:text-blueGray-700"
                  style={{ cursor: "pointer", marginBottom: "10px" }}
                >
                  <i className="fa fa-arrow-left" /> Back to Nodes
                </div>{" "}
              </div>
              <h3 className="font-bold text-lg text-blueGray-700">
                {localNode.name}
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={() =>
                    NiceModal.show("test-node", { node_id: localNode.id })
                  }
                >
                  Test
                </Button>
              </h3>
              <NodeForm node_id={localNode.public_id} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Node;
